module.exports = __webpack_public_path__ + "static/media/add-icon-hover.197ed9f5.svg";